import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { K365SetupGuidesAccessState } from '@layout/k365-setup-guides-access/store/states/k365-setup-guides-access.state';
import {
  LoadK365SetupGuidesAccessIfNotLoaded,
  SetK365SetupGuidesAccessInactive,
} from '@layout/k365-setup-guides-access/store/actions/k365-setup-guides-access.actions';

@Injectable({
  providedIn: 'root',
})
export class K365SetupGuidesAccessFacade {
  private readonly store = inject(Store);

  readonly setupGuidesAccess$ = this.store.select(K365SetupGuidesAccessState.setupGuidesAccess);
  readonly loading$ = this.store.select(K365SetupGuidesAccessState.loading);
  readonly error$ = this.store.select(K365SetupGuidesAccessState.error);

  setSetupGuidesAccessInactive(): void {
    this.store.dispatch(new SetK365SetupGuidesAccessInactive());
  }

  loadSetupGuidesAccessIfNotLoaded(): void {
    this.store.dispatch(new LoadK365SetupGuidesAccessIfNotLoaded());
  }
}
